export default __webpack_public_path__ + "static/media/chatbot-project.54e1de94.png";